export const GET_ENTITY_SEARCH = "GET_ENTITY_SEARCH";
export const RESET_ENTITY_SEARCH = "RESET_ENTITY_SEARCH";
